@if (type === 'prev') {
  <i class="fa-solid fa-chevron-left text-cb-gold text-20"></i>
}

<div>
  @if (type === 'next') {
    Next
  } @else {
    Previous
  }
</div>

@if (type === 'next') {
  <i class="fa-solid fa-chevron-right text-white text-20"></i>
}
